import React from 'react';
import { ChevronUp, ChevronDown, Trash2Icon } from 'lucide-react';
import TooltipWrapper from './ui/TooltipWrapper';

type NodeEditorActionProps = {
    nodeKey: number,
    onChevronUp: (key: number) => void,
    onChevronDown: (key: number) => void,
    onDelete: (key: number) => void
};

const NodeEditorAction = ({ nodeKey, onChevronUp, onChevronDown, onDelete }: NodeEditorActionProps) => {
    const onChevronUpClick = () => {
        onChevronUp(nodeKey);
    }

    const onChevronDownClick = () => {
        onChevronDown(nodeKey);
    }

    const onDeleteClick = () => {
        onDelete(nodeKey);
    }

    return (
        <div className="flex-initial border-l px-3 py-3 flex flex-wrap">
            <TooltipWrapper trigger={<ChevronUp className='me-2 cursor-pointer' onClick={onChevronUpClick} />} message="Move up" />
            <TooltipWrapper trigger={<ChevronDown className='me-2 cursor-pointer' onClick={onChevronDownClick}/>} message="Move down" />
            <TooltipWrapper trigger={<Trash2Icon className='cursor-pointer' onClick={onDeleteClick}/>} message="Delete" />
        </div>
    )
}

export default NodeEditorAction;